module.exports = __webpack_public_path__ + "static/media/hellman.ac0cfeea.png";